import { gql } from '@apollo/client'

export const INTEGRATIONS_QUERY = gql`
  query FindIntegrations {
    integrations {
      id
      name
      displayName
      description
      IntegrationOperation {
        id
        operationName
        description
      }
    }
  }
`
